import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { loadingState, loadingText } from "../states/loadingState";
import apiClient from "../lib/apiClient";

export const useUpdateProcesses = () => {
  const [putError, setputError] = useState<string | null>(null);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const updateProcessesPt = async (
    processData: any,
    recordNo: number,
    email: string
  ) => {
    console.log("processData", processData, recordNo, email);
    setputError(null);
    setLoadingAnimation(true);
    setLoadingText("送信中...");
    try {
      const res = await apiClient.put(
        `/process/updateInputProcess/pt/${recordNo}/${email}`,
        processData
      );
    } catch (error) {
      setputError("エラー:更新に失敗しました: " + error);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  const updateProcessesPv = async (
    processData: any,
    recordNo: number,
    email: string
  ) => {
    console.log("processData", processData, recordNo, email);
    setputError(null);
    setLoadingAnimation(true);
    setLoadingText("送信中...");
    try {
      const res = await apiClient.put(
        `/process/updateInputProcess/pv/${recordNo}/${email}`,
        processData
      );
    } catch (error) {
      setputError("エラー:更新に失敗しました: " + error);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  return { putError, updateProcessesPt, updateProcessesPv };
};
